import { cn } from "@/lib/utils";

interface BlueprintBackgroundProps {
  children: React.ReactNode;
  className?: string;
  subtle?: boolean;
}

export function BlueprintBackground({
  children,
  className,
  subtle = false,
}: BlueprintBackgroundProps) {
  return (
    <div
      className={cn(
        subtle ? "blueprint-bg-subtle" : "blueprint-bg",
        className,
      )}
    >
      {children}
    </div>
  );
}
